import React, { useState, useEffect } from 'react';
import { Button } from '@material-ui/core';
import LoopIcon from '@material-ui/icons/Loop';
import DirectionsBikeIcon from '@material-ui/icons/DirectionsBike';
import axios from 'axios';
import { useStore } from 'react-redux';

export default function PickupRequest() {
  const store: any = useStore();

  const [loading, setloading] = useState(false);

  const [get_pickupRequest, setPickupRequest]: [any, any] = useState(false);

  async function fetch_pickup_request() {
    await axios
      .get(`${process.env.REACT_APP_API_SERVER}/pickup-requests/active`, {
        headers: {
          Authorization: `Bearer ${store.getState().auth.jwt}`,
        },
      })
      .then((res) => {
        if (res.data.id) {
          setPickupRequest(res.data);
        } else {
          setPickupRequest(false);
        }
      });
  }
  useEffect(() => {
    fetch_pickup_request();
    const interval = setInterval(fetch_pickup_request, 5000);
    return () => {
      clearInterval(interval);
    };
    // eslint-disable-next-line
  }, []);

  async function createPickupRequest(jwt: any) {
    setloading(true);
    await axios
      .post(
        `${process.env.REACT_APP_API_SERVER}/pickup-requests`,
        {},
        {
          headers: { Authorization: `Bearer ${jwt}` },
        },
      )
      .then((res) => {
        setPickupRequest(res.data);
      })
      .finally(() => {
        setloading(false);
      });
  }

  async function cancelPickupRequest(jwt: any) {
    await axios
      .delete(`${process.env.REACT_APP_API_SERVER}/pickup-requests`, {
        headers: {
          Authorization: `Bearer ${jwt}`,
        },
      })
      .then((res) => {
        if (res.data) {
          setPickupRequest(false);
        }
      });
  }

  if (get_pickupRequest.id) {
    return (
      <div>
        Pickup request Status: <b> {get_pickupRequest.status}</b> <br />
        <b>
          {get_pickupRequest?.rider?.name
            ? `Rider: ${get_pickupRequest?.rider?.name}${
                get_pickupRequest?.rider?.number ? `(${get_pickupRequest?.rider?.number})` : ''
              }`
            : ''}
        </b>
        <br />
        <span> Do you want to cancel it? Click </span>
        <Button
          variant="contained"
          color="secondary"
          onClick={async () => {
            await cancelPickupRequest(store.getState().auth.jwt);
          }}
        >
          Cancel
        </Button>
      </div>
    );
  } else {
    return (
      <Button
        onClick={async () => {
          await createPickupRequest(store.getState().auth.jwt);
        }}
        variant="contained"
        color="primary"
        startIcon={loading ? <LoopIcon /> : <DirectionsBikeIcon />}
      >
        Pickup Request
      </Button>
    );
  }
}
